import React from "react";

import Logo from "../../assets/img/casc_logo.png";

import * as _ from "lodash";

// import { AiOutlineCheck } from "react-icons/ai";

const _arrId = [
  "check-info",
  "verify-otp",
  // "type-account",
  "personal",
  "organization",
  "complete-info",
  "verify",
];

function NavLeft({ step }) {
  const _stepIndex = _.findIndex(_arrId, (o) => o === step);

  return (
    <div className={"sidebar sidebar-steps sidebar-bg-" + step}>
      <div className="logo">
        <a href="#">
          <img className="light-logo" src={Logo} alt="" />
          {/* <img className="dark-logo" src={Logo} alt="" /> */}
        </a>
      </div>
      <div className="steps">
        <div
          className={
            "step step-otp " +
            (step === "verify-otp" || _stepIndex > 1 ? "step-onprocess " : "")
          }
        >
          <span />
          <p className="text-center">OTP</p>
        </div>
        {/* <div
          className={
            "step step-account " +
            (step === "type-account" || _stepIndex > 2 ? "step-onprocess " : "")
          }
        >
          <span />
          <div className="line"></div>
          <p className="text-center">Loại tài khoản</p>
        </div> */}
        <div
          className={
            "step step-complete " +
            (step === "personal" || step === "organization" || _stepIndex > 2
              ? "step-onprocess "
              : "")
          }
        >
          <span>
            {/* {step === "personal" && _stepIndex > 3 && <AiOutlineCheck />}
            {step === "organization" && _stepIndex > 4 && <AiOutlineCheck />} */}
          </span>
          <div className="line"></div>
          <p className="text-center">
            {/* Hoàn thiện <br /> thông tin */}
            Tải ảnh CMND/CCCD
          </p>
        </div>
        <div
          className={
            "step step-verify " +
            (step === "complete-info" || _stepIndex > 4
              ? "step-onprocess "
              : "")
          }
        >
          <span></span>
          <div className="line"></div>
          <p className="text-center">
            Xác thực thông tin
          </p>
        </div>
        <div
          className={
            "step step-success " +
            (step === "verify" || _stepIndex > 5 ? "step-onprocess " : "")
          }
        >
          <span></span>
          <div className="line"></div>
          <p className="text-center">
            Đăng ký dịch vụ
          </p>
        </div>
      </div>
    </div>
  );
}

export default NavLeft;
